const THROTTLE_DELAY = 16;
const TRANSITION_DURATION = "0.1s";

const SCALE_DESKTOP = {
  minHeight: 0,
  maxHeight: Infinity,
  minScaleX: 1,
  minScaleY: 1,
  maxScaleX: 1,
  maxScaleY: 1,
};

const SCALE_TABLET = {
  minHeight: 630,
  maxHeight: 1268,
  minScaleX: 0.462068965517,
  minScaleY: 0.462295081967,
  maxScaleX: 0.962389380531,
  maxScaleY: 0.97,
};

const SCALE_PHONE = {
  minHeight: 630,
  maxHeight: 864,
  minScaleX: 0.53, // orig was: 0.6
  minScaleY: 0.53, // orig was: 0.6
  maxScaleX: 0.79, // orig was: 0.9
  maxScaleY: 0.79, // orig was: 0.9
};

const SCALE_CONFIG = {
  desktop: SCALE_DESKTOP,
  tablet: SCALE_TABLET,
  phone: SCALE_PHONE,
};

export function destroyScale() {
  clearTimeout(timeout);
}

const calcScale = type => SCALE_CONFIG[type] || SCALE_CONFIG.desktop;

let timeout;

export function initScale(selector) {
  const el = document.querySelector(selector);
  if (!el) return;
  el.style.transition = `transform ${TRANSITION_DURATION}`;
  el.style.transformOrigin = "center top";

  let type;
  if (el.classList.contains("tablet")) type = "tablet";
  else if (el.classList.contains("mobile")) type = "phone";
  else if (el.classList.contains("desktop")) type = "desktop";

  const update = () => {
    if (type === "desktop") {
      el.style.transform = "none";
      return;
    }

    const height = window.innerHeight;
    const viewParams = calcScale(type);

    const {
      minHeight, maxHeight, minScaleX, minScaleY, maxScaleX, maxScaleY,
    } = viewParams;

    const clamped = Math.min(Math.max(height, minHeight), maxHeight);
    const heightRatio = (clamped - minHeight) / (maxHeight - minHeight);

    const scaleX = minScaleX + (maxScaleX - minScaleX) * heightRatio;
    const scaleY = minScaleY + (maxScaleY - minScaleY) * heightRatio;

    el.style.transform = `scale(${scaleX}, ${scaleY})`;
  };

  window.addEventListener("resize", () => {
    clearTimeout(timeout);
    timeout = setTimeout(update, THROTTLE_DELAY);
  });

  update();
}
